export default __webpack_public_path__ + "static/attribute2-dark-8dc4d9bcf34314c91a5fd678c5156632.png";